<div class="modal-container">
  <button type="button" class="close-button pull-right" (click)="hide()">
    <img src="assets/cb/images/close-icon.png" alt="Close" />
  </button>
  <div class="left-col">
    <div class="information-container">
      <h4>Shape Library</h4>
      <!-- <mat-form-field>
      <input matInput type="text">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field> -->
    <ul>
      @for (collection of shapeCollections; track trackByFn($index, collection)) {
        <li tabindex="0" role="button" [attr.aria-label]="'Jump to ' + collection.name + ' shapes'"
          (click)="scroll('shape-collection-' + collection.id)"
          (keydown.enter)="scroll('shape-collection-' + collection.id)"
          (keydown.space)="scroll('shape-collection-' + collection.id); $event.preventDefault()">
        {{collection.name}} </li>
      }
    </ul>
  </div>
</div>
<div class="pattern-container">
  @for (collection of shapeCollections; track trackByFn($index, collection)) {
    <div>
      <h5 id="shape-collection-{{collection.id}}" tabindex="-1">{{collection.name | uppercase}}</h5>
      <div class="patterns-list">
        @for (shape of getCollectionShapes(collection.id); track trackByFn($index, shape)) {
          <button type="button" class="shape-button" [attr.aria-label]="'Add ' + shape.name + ' shape'" (click)="addShape(shape)">
            <app-canvas-shape [shape]="shape" [location]="'library'">
            </app-canvas-shape>
          </button>
        }
      </div>
    </div>
  }
</div>
</div>
